module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar deleteGranted = false;\nif((storage || {}).user) {\ndeleteGranted = storage.user.hasAccessTo(config.privilegeBase + ':delete', 'art_crm');\n}\n%>\n<div>\n<%\nif(model.parentAddressID > 0){\n%>\n<section class=\"head\">\n<h2><%= storage.__('addresses.contactList.headline') %></h2>\n<div class=\"buttons\">\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'contact', symbolOnly: false, positive: true } }); %>\n</div>\n</section>\n<section class=\"content\">\n<%\nvar d, data, attributes, f, field, head, value;\nvar dataLength = (resourceData.data || []).length || 0;\nvar translationKey = false;\nvar langCode = storage.langCode || 'de-at';\nvar relationConfig;\nvar showIDs = false;\nif(storage.user){\nshowIDs = storage.user.hasRoleOption('showIDs', 'art_crm');\n}\nif(dataLength > 0){\nfor(d in resourceData.data || []){\ndata = resourceData.data[d] || {};\nattributes = data.attributes || {};\nprimaryKeyName = data.primaryKey || 'id';\nprimaryKey = attributes[data.primaryKey || 'id'];\n%>\n<div class=\"listRow\" data-row-id=\"<%- primaryKey %>\">\n<div class=\"listCols\">\n<%\nfor(f in model.fields || []){\nfield = model.fields[f] || {};\nvalue = '';\nif(field.fieldCode !== primaryKeyName || showIDs){\nif(field.fieldCode && field.atom){\n// prevent field value if necessary\nif(\n(field.fieldCode !== 'contactType' || (attributes[field.fieldCode] !== 'default' && attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== ''))\n&&\n(field.fieldCode !== 'salutation' || (attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== ''))\n&&\n(field.fieldCode !== 'active' || (attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== false))\n){\nif((value = attributes[field.fieldCode])){\nif(field.atom.dataType === 'boolean'){\nvalue = storage.__('dataValues.' + field.atom.dataType + '.' + value);\n}\nelse if(field.atom.dataType === 'category-picker') {\nvar o, option, categoryNameFound = false;\nfor(o in (field['category-picker-data'] || {}).options || []){\nif((option = field['category-picker-data'].options[o]).value === value){\nif(((option.lang || {})[langCode] || {}).name){\nvalue = option.lang[langCode].name;\ncategoryNameFound = true;\n}\nbreak;\n}\n}\nif(!categoryNameFound) value = '';\n}\nelse if(field.atom.dataType === 'datetime') {\nvalue = utils.moment(value).format((field.config || {}).momentDateFormat || 'dd.mm.yyyy');\n}\nelse if(field.atom.dataType === 'json'){\nvalue = JSON.stringify(value);\n}\n}\nelse if(field.atom.dataType === 'tag-picker' && (relationConfig = (field.config || {}).relationConfig)){\nvar categories = (((data || {})[relationConfig.subFormAliasContainer || 'children'] || {})[relationConfig.subFormAlias || 'cms_entities_categories'] || {}).data || []\nvar bubbles = [], categoryData, tag, c;\nif(categories.length > 0){\nfor(c in categories){\ncategoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};\ntag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'\nif(showIDs){\ntag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag\n}\nbubbles.push('<div class=\"bubble\">' + tag + '</div>');\n}\nvalue = '<div class=\"bubbles\">' + (bubbles.join('') || '') + '</div>';\n} else {\nvalue = ''\n}\n}\n}\n}\n}\nif(value){\nhead = ((field.lang || {})[langCode] || {}).label || field.fieldCode || 'UNKNOWN';\nif(field.fieldCode === 'email' || field.fieldCode === 'emailNewsletter' || field.fieldCode === 'emailBusiness' || field.fieldCode === 'emailPrivate'){\nvalue = '<a href=\"mailto:' + value + '\">' + value + '</a>'\n} else if(field.fieldCode === 'mobile' || field.fieldCode === 'mobileBusiness' || field.fieldCode === 'mobilePrivate' || field.fieldCode === 'phone' || field.fieldCode === 'phoneBusiness' || field.fieldCode === 'phonePrivate'){\nvalue = '<a href=\"tel:' + value + '\">' + value + '</a>'\n} else if(field.fieldCode === 'website' || field.fieldCode === 'websiteBusiness' || field.fieldCode === 'websitePrivate'){\nvar url = value;\nif(String(url).indexOf('http://') === -1 && String(url).indexOf('https://') === -1){\nurl = 'http://' + url\n}\nvalue = '<a target=_blank href=\"' + url + '\">' + value + '</a>'\n}\n%>\n<div class=\"listCol\">\n<div class=\"head\"><%= head %></div>\n<div class=\"content\"><%- value %></div>\n</div>\n<%\n}\n}\n%>\n</div>\n<div class=\"buttons\">\n<%\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'move', context: 'contact', mode: 'down', symbolOnly: true } }); %><%\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'move', context: 'contact', mode: 'up', symbolOnly: true } }); %><%\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'contact', symbolOnly: true, positive: true } }); %><%\nif(deleteGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'contact', symbolOnly: true } }); %><%\n}\n%>\n</div>\n</div>\n<%\n}\n}\nelse {\n%><div class=\"listRow emptyRow\"><%= storage.__('addresses.contactList.emptyRow'); %></div><%\n}\n%>\n</section>\n<%\n}\n%>\n</div>"
  , __filename = "components/templates/artCrm/contactList/contactList.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var deleteGranted = false;
if((storage || {}).user) {
deleteGranted = storage.user.hasAccessTo(config.privilegeBase + ':delete', 'art_crm');
}

    ; __line = 6
    ; __append("\n<div>\n")
    ; __line = 8
    ; 
if(model.parentAddressID > 0){

    ; __line = 10
    ; __append("\n<section class=\"head\">\n<h2>")
    ; __line = 12
    ; __append(escapeFn( storage.__('addresses.contactList.headline') ))
    ; __append("</h2>\n<div class=\"buttons\">\n")
    ; __line = 14
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'contact', symbolOnly: false, positive: true } }) )
    ; __append("\n</div>\n</section>\n<section class=\"content\">\n")
    ; __line = 18
    ; 
var d, data, attributes, f, field, head, value;
var dataLength = (resourceData.data || []).length || 0;
var translationKey = false;
var langCode = storage.langCode || 'de-at';
var relationConfig;
var showIDs = false;
if(storage.user){
showIDs = storage.user.hasRoleOption('showIDs', 'art_crm');
}
if(dataLength > 0){
for(d in resourceData.data || []){
data = resourceData.data[d] || {};
attributes = data.attributes || {};
primaryKeyName = data.primaryKey || 'id';
primaryKey = attributes[data.primaryKey || 'id'];

    ; __line = 34
    ; __append("\n<div class=\"listRow\" data-row-id=\"")
    ; __line = 35
    ; __append( primaryKey )
    ; __append("\">\n<div class=\"listCols\">\n")
    ; __line = 37
    ; 
for(f in model.fields || []){
field = model.fields[f] || {};
value = '';
if(field.fieldCode !== primaryKeyName || showIDs){
if(field.fieldCode && field.atom){
// prevent field value if necessary
if(
(field.fieldCode !== 'contactType' || (attributes[field.fieldCode] !== 'default' && attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== ''))
&&
(field.fieldCode !== 'salutation' || (attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== ''))
&&
(field.fieldCode !== 'active' || (attributes[field.fieldCode] !== null && attributes[field.fieldCode] !== false))
){
if((value = attributes[field.fieldCode])){
if(field.atom.dataType === 'boolean'){
value = storage.__('dataValues.' + field.atom.dataType + '.' + value);
}
else if(field.atom.dataType === 'category-picker') {
var o, option, categoryNameFound = false;
for(o in (field['category-picker-data'] || {}).options || []){
if((option = field['category-picker-data'].options[o]).value === value){
if(((option.lang || {})[langCode] || {}).name){
value = option.lang[langCode].name;
categoryNameFound = true;
}
break;
}
}
if(!categoryNameFound) value = '';
}
else if(field.atom.dataType === 'datetime') {
value = utils.moment(value).format((field.config || {}).momentDateFormat || 'dd.mm.yyyy');
}
else if(field.atom.dataType === 'json'){
value = JSON.stringify(value);
}
}
else if(field.atom.dataType === 'tag-picker' && (relationConfig = (field.config || {}).relationConfig)){
var categories = (((data || {})[relationConfig.subFormAliasContainer || 'children'] || {})[relationConfig.subFormAlias || 'cms_entities_categories'] || {}).data || []
var bubbles = [], categoryData, tag, c;
if(categories.length > 0){
for(c in categories){
categoryData = ((categories[c].children || {}).cms_categoriesData || {}).data || {};
tag = (((categoryData.attributes || {}).trls || {})[langCode] || {}).name || 'UNKNOWN_TAG'
if(showIDs){
tag = '[' + (categoryData.attributes || {})[categoryData.primaryKey || 'categoryDataID'] + '] ' + tag
}
bubbles.push('<div class="bubble">' + tag + '</div>');
}
value = '<div class="bubbles">' + (bubbles.join('') || '') + '</div>';
} else {
value = ''
}
}
}
}
}
if(value){
head = ((field.lang || {})[langCode] || {}).label || field.fieldCode || 'UNKNOWN';
if(field.fieldCode === 'email' || field.fieldCode === 'emailNewsletter' || field.fieldCode === 'emailBusiness' || field.fieldCode === 'emailPrivate'){
value = '<a href="mailto:' + value + '">' + value + '</a>'
} else if(field.fieldCode === 'mobile' || field.fieldCode === 'mobileBusiness' || field.fieldCode === 'mobilePrivate' || field.fieldCode === 'phone' || field.fieldCode === 'phoneBusiness' || field.fieldCode === 'phonePrivate'){
value = '<a href="tel:' + value + '">' + value + '</a>'
} else if(field.fieldCode === 'website' || field.fieldCode === 'websiteBusiness' || field.fieldCode === 'websitePrivate'){
var url = value;
if(String(url).indexOf('http://') === -1 && String(url).indexOf('https://') === -1){
url = 'http://' + url
}
value = '<a target=_blank href="' + url + '">' + value + '</a>'
}

    ; __line = 108
    ; __append("\n<div class=\"listCol\">\n<div class=\"head\">")
    ; __line = 110
    ; __append(escapeFn( head ))
    ; __append("</div>\n<div class=\"content\">")
    ; __line = 111
    ; __append( value )
    ; __append("</div>\n</div>\n")
    ; __line = 113
    ; 
}
}

    ; __line = 116
    ; __append("\n</div>\n<div class=\"buttons\">\n")
    ; __line = 119
    ; 

    ; __line = 120
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'move', context: 'contact', mode: 'down', symbolOnly: true } }) )
    ; 

    ; __line = 121
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'move', context: 'contact', mode: 'up', symbolOnly: true } }) )
    ; 

    ; __line = 122
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'contact', symbolOnly: true, positive: true } }) )
    ; 
if(deleteGranted){

    ; __line = 124
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'contact', symbolOnly: true } }) )
    ; 
}

    ; __line = 126
    ; __append("\n</div>\n</div>\n")
    ; __line = 129
    ; 
}
}
else {

    ; __line = 133
    ; __append("<div class=\"listRow emptyRow\">")
    ; __append(escapeFn( storage.__('addresses.contactList.emptyRow') ))
    ; __append("</div>")
    ; 
}

    ; __line = 135
    ; __append("\n</section>\n")
    ; __line = 137
    ; 
}

    ; __line = 139
    ; __append("\n</div>")
    ; __line = 140
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/contactList/contactList.ejs

}